<template>
	<span :class="['app-tooltip', `app-tooltip-${placement}`]" :data-app-tip="text">
		<slot />
	</span>
</template>

<script>
const PLACEMENTS = [
	"top-end",
	"top-start",
	"top",
	"bottom-end",
	"bottom-start",
	"bottom",
];

export default {
	name: "Tooltip",
	props: {
		text: { type: String, required: true },
		placement: {
			type: String,
			default: "bottom-end",
			validator: (value) => PLACEMENTS.includes(value),
		},
	},
};
</script>

<style scoped>
.app-tooltip {
	position: relative;
	display: inline-block;
}

.app-tooltip::after,
.app-tooltip::before {
	opacity: 0;
	pointer-events: none;
	transition: opacity 0.12s ease 0.12s;
	position: absolute;
	z-index: 1000;
}

.app-tooltip::after {
	content: attr(data-app-tip);
	background: #1f2937;
	color: #ffffff;
	padding: 6px 10px;
	border-radius: 6px;
	font-size: 12px;
	font-weight: 500;
	line-height: 1.35;
	white-space: normal;
	width: max-content;
	max-width: min(320px, calc(100vw - 32px));
	overflow-wrap: anywhere;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.app-tooltip::before {
	content: "";
	width: 8px;
	height: 6px;
	background: #1f2937;
}

.app-tooltip:hover::after,
.app-tooltip:hover::before,
.app-tooltip:focus-within::after,
.app-tooltip:focus-within::before {
	opacity: 1;
}

.app-tooltip-top-end::after,
.app-tooltip-top-start::after,
.app-tooltip-top::after {
	bottom: calc(100% + 6px);
}

.app-tooltip-top-end::before,
.app-tooltip-top-start::before,
.app-tooltip-top::before {
	bottom: calc(100% + 2px);
	clip-path: polygon(0 0, 100% 0, 50% 100%);
}

.app-tooltip-top-end::after {
	right: 0;
}

.app-tooltip-top-end::before {
	right: 4px;
}

.app-tooltip-top-start::after {
	left: 0;
}

.app-tooltip-top-start::before {
	left: 4px;
}

.app-tooltip-top::after {
	left: 50%;
	transform: translateX(-50%);
}

.app-tooltip-top::before {
	left: 50%;
	transform: translateX(-50%);
}

.app-tooltip-bottom-end::after,
.app-tooltip-bottom-start::after,
.app-tooltip-bottom::after {
	top: calc(100% + 6px);
}

.app-tooltip-bottom-end::before,
.app-tooltip-bottom-start::before,
.app-tooltip-bottom::before {
	top: calc(100% + 2px);
	clip-path: polygon(0 100%, 100% 100%, 50% 0);
}

.app-tooltip-bottom-end::after {
	right: 0;
}

.app-tooltip-bottom-end::before {
	right: 4px;
}

.app-tooltip-bottom-start::after {
	left: 0;
}

.app-tooltip-bottom-start::before {
	left: 4px;
}

.app-tooltip-bottom::after {
	left: 50%;
	transform: translateX(-50%);
}

.app-tooltip-bottom::before {
	left: 50%;
	transform: translateX(-50%);
}</style>
